import { LogoMark } from '../components/LogoMark';

// Filename versioned ("-v2") to bust WeChat in-app browser image cache when the QR
// content changes. Bump the suffix whenever the QR is regenerated.
const SEED_GROUP_QR = '/icons/seed-group-qr-v2.png';

export function MobileHint() {
  const url = 'https://starter.cyberunion.net';

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      alert('链接已经复制好,到电脑上粘贴打开就回到桌面。');
    } catch {
      window.prompt('手动复制下面这段链接:', url);
    }
  }

  return (
    <main className="wrap mobile-hint">
      <header className="topbar">
        <div className="brand">
          <LogoMark size={32} title="每日启动器" />
          <span className="brand-text">
            <strong>每日启动器</strong>
            <em>赛博神经出品</em>
          </span>
        </div>
      </header>

      <section className="panel">
        <span className="tiny-label">
          <i className="dot cyan" /> 这张桌面更适合在电脑上打开
        </span>
        <h1>先把入口留住,回到电脑再开始</h1>
        <p>
          每日启动器的三卡桌面需要一点空间。手机上不用硬挤进工作台,我们想让第一轮开始得更安静一点。在电脑上打开 <strong>starter.cyberunion.net</strong> 就可以。
        </p>

        <div className="actions">
          <button className="btn-lime" onClick={copyLink}>
            复制电脑打开链接
          </button>
          <a className="btn-ghost" href="#seed-group">
            加入种子用户群
          </a>
        </div>
      </section>

      <section id="seed-group" className="panel editorial">
        <span className="tiny-label">
          <i className="dot amber" /> 进群领邀请码
        </span>
        <strong>每日启动器是邀请制内测</strong>
        <p>
          邀请码在种子群里发。扫码进群,跟群主领一个,然后回到电脑端打开{' '}
          <strong>starter.cyberunion.net</strong>,就可以开始第一段。
        </p>
        <div className="qr-placeholder">
          <img src={SEED_GROUP_QR} alt="种子群二维码 — 扫码进群领邀请码" />
        </div>
      </section>

      <footer className="footer">
        <span>来自创作者 @赛博神经 · CyberUnion 第一个 C 端产品</span>
      </footer>
    </main>
  );
}
